import { CSSProperties, memo } from "react";
import { Box, BoxProps, Center, keyframes, Square } from "@chakra-ui/react";
import { useWindowSize } from "../hooks/useWindowSize";

const linesAmount = 16;

export const Spinner = memo(({ zoom = 1 }: { zoom?: number }) => (
  <Square size="25" css={{ zoom }} display="inline-block" overflow="hidden" color="inherit">
    <Box {...SpinnerStyles}>
      {Array(linesAmount)
        .fill(0)
        .map((_, index) => (
          <Box key={index} />
        ))}
    </Box>
  </Square>
));

export const PageSpinner = () => {
  const { height = 0 } = useWindowSize();

  return (
    <Center minH={`max(${height}px, 100vh)`} color="white">
      <Spinner />
    </Center>
  );
};

const spinnerAnimation = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`;

const SpinnerStyles: BoxProps = {
  width: "full",
  height: "full",
  position: "relative",
  transform: "translateZ(0) scale(1)",
  transformOrigin: "0 0",
  color: "currentColor",
  css: {
    "& > div": {
      left: 45,
      top: 5,
      position: "absolute",
      animation: `${spinnerAnimation} linear 1s infinite`,
      background: "currentColor",
      width: "10px",
      height: "28px",
      transformOrigin: "4.1px 45.919999999999995px",
      clipPath: "polygon(0 0, 100% 0, 70% 100%, 30% 100%)",
      boxSizing: "content-box",
    },
    ...(() => {
      const styles = {} as { [key: string]: CSSProperties };

      const angle = 360 / linesAmount;
      const delayStep = 1000 / linesAmount / 1000;

      for (let i = 0; i < linesAmount; i += 1) {
        styles[`& > div:nth-of-type(${i + 1})`] = {
          transform: `rotate(${angle * i}deg)`,
          animationDelay: `${delayStep * i - 1000}s`,
        };
      }

      return styles;
    })(),
  },
};
